import { render, staticRenderFns } from "./SubheaderItem.vue?vue&type=template&id=0e1223c6&scoped=true"
import script from "./SubheaderItem.vue?vue&type=script&lang=ts"
export * from "./SubheaderItem.vue?vue&type=script&lang=ts"
import style0 from "./SubheaderItem.vue?vue&type=style&index=0&id=0e1223c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1223c6",
  null
  
)

export default component.exports